import Button from '@mui/material/Button';
import React from 'react';

interface Props {
  onClick: () => void;
  danger?: boolean;
  text: string;
}

const SubmitButton: React.FC<Props> = ({ onClick, text }) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        textTransform: 'initial',
        backgroundColor: 'var(--olymp-robot-alt-surface, #2f415b)',
      }}
      fullWidth
    >
      {text}
    </Button>
  );
};

export default React.memo(SubmitButton);
